/**
 *
 * Asynchronously loads the component for AdminValidatorDetails
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/AdminValidatorDetails/loadable.js